import { Button, ModalV2 } from '@skand/ui';

export interface SaveCalculationModalProps {
  open: boolean;
  onUpdate: () => void;
  onCancel: () => void;
  onDontSave: () => void;
}

export const SaveCalculationModal = ({
  open,
  onCancel,
  onUpdate,
  onDontSave,
}: SaveCalculationModalProps) => {
  return (
    <ModalV2 open={open}>
      <div className="mt-1 flex flex-col gap-6">
        <p className="color-neutral-800 typo-text-m">Unsaved Changes</p>
        <p className="color-neutral-800 typo-text-s">
          You have unsaved measurements. Are you sure you want to close without saving them?
        </p>
      </div>
      <div className="mt-4 w-full flex gap-2">
        <Button className="w-full cursor-pointer" onClick={onCancel} size="s">
          Cancel
        </Button>
        <Button className="w-full cursor-pointer" onClick={onDontSave} size="s">
          Don’t save
        </Button>
        <Button className="w-full cursor-pointer" filled onClick={onUpdate} primary size="s">
          Update
        </Button>
      </div>
    </ModalV2>
  );
};
